import { render, staticRenderFns } from "./LoginFailed.vue?vue&type=template&id=f007ad06&"
import script from "./LoginFailed.vue?vue&type=script&lang=js&"
export * from "./LoginFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports